/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.ai.rpc.CommerceGenerationService
 */

export const generateBuyerEmailRpc = {
  serviceName: 'com.hubspot.commerce.ai.rpc.CommerceGenerationService',
  rpcName: 'generateBuyerEmail',
  auth: 'app',
  fingerprint: 'jMzqoFeBWCPQ5P4Y-i1WBSvQBLUs6hhy',
  na1Only: false,
  isStreaming: false
};